import { FieldData, FieldDataServer } from 'interfaces/api/templates.interfaces'

export const fieldsMapper = (data: FieldData): FieldDataServer => ({
  title: {
    en: data.title,
    ru: data.title,
  },
  code: data.code,
  isRequired: data.isRequired,
  businessTypeId: data.businessTypeId,
})
